import {register} from '../vendor/theme-scripts/theme-sections';

const selectors = {
  popup: '[data-popup]',
  close: '[data-popup-close]',
  reappearTime: 'data-reappear_time',
  delay: 'data-delay',
  testmode: 'data-testmode',
  checkTrueString: 'true',
};

const classes = {
  popupVisible: 'popup--visible',
};

let sections = {};

class PopupCookie {
  constructor(name, value, expires) {
    this.configuration = {
      expires: expires, // session cookie
      path: '/',
      domain: window.location.hostname,
    };
    this.name = name;
    this.value = value;
  }

  write() {
    const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find((row) => row.startsWith(this.name));
    if (hasCookie || document.cookie.indexOf('; ') === -1) {
      document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    }
  }

  read() {
    if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
      const returnCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(this.name))
        .split('=')[1];

      return returnCookie;
    } else {
      return false;
    }
  }

  destroy() {
    if (document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
      document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    }
  }
}

class Popup {
  constructor(el) {
    this.popup = el;
    this.close = this.popup.querySelector(selectors.close);
    this.timeout = 0;
    this.testmode = this.popup.getAttribute(selectors.testmode) === selectors.checkTrueString;
    this.delay = parseInt(this.popup.getAttribute(selectors.delay)) * 1000;
    this.cookie = new PopupCookie('newsletter', 'user_has_closed', this.expireDate());

    this.init();
  }

  expireDate() {
    const todayDate = new Date();
    const expireDate = new Date();
    let date = parseInt(this.popup.getAttribute(selectors.reappearTime));

    if (date !== 0) {
      expireDate.setTime(todayDate.getTime() + 3600000 * 24 * date);
    } else {
      expireDate.setTime(todayDate.getTime() + 3600000 * 24 * 365 * 100);
    }

    date = expireDate.toGMTString();

    return date;
  }

  init() {
    const cookieExists = this.cookie.read() !== false;

    if (!cookieExists || this.testmode) {
      this.timeout = setTimeout(() => {
        this.popup.classList.add(classes.popupVisible);
        this.initClosers();
        this.close.focus();
      }, this.delay);
    }
  }

  initClosers() {
    this.close.addEventListener('click', this.closeModal.bind(this));
  }

  closeModal(e) {
    e.preventDefault();
    this.popup.classList.remove(classes.popupVisible);
    clearTimeout(this.timeout);

    if (!this.testmode) {
      this.cookie.write();
    }
  }
}

const popupSection = {
  onLoad() {
    const popup = this.container.querySelector(selectors.popup);
    if (popup !== null) {
      sections[this.id] = new Popup(popup);
    }
  },
};

register('popup', popupSection);
